import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=67e1a60c&scoped=true"
import script from "./PromotionForm.vue?vue&type=script&lang=js"
export * from "./PromotionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e1a60c",
  null
  
)

export default component.exports